'use strict'
module.exports = require('./lib')(require('./lib/elliptic'))



//////////////////
// WEBPACK FOOTER
// ./~/secp256k1/elliptic.js
// module id = 1247
// module chunks = 0